import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles(() => ({
  root: {
    "& > .CustomMui-collapseIconWrapper": {
      display: "none"
    },
    "& > .CustomMui-collapseIconWrapper, & > .CustomMui-expandIconWrapper": {
      width: 24,
      height: 24
    }
  },
  "@global": {
    ".MuiAccordionSummary-expandIcon.Mui-expanded .CustomMui-expandIconWrapper":
      {
        display: "none"
      },
    ".MuiAccordionSummary-expandIcon.Mui-expanded .CustomMui-collapseIconWrapper":
      {
        display: "block"
      }
  }
}));
